import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Layout } from "@/components/layout/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ReviewsIndex from "@/pages/ReviewsIndex";
import ReviewPage from "@/pages/ReviewPage";
import UseCasesIndex from "@/pages/UseCasesIndex";
import UseCasePage from "@/pages/UseCasePage";
import GuidesIndex from "@/pages/GuidesIndex";
import GuidePage from "@/pages/GuidePage";
import ComparisonMatrix from "@/pages/ComparisonMatrix";
import Resources from "@/pages/Resources";
import About from "@/pages/About";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AffiliateDisclosure from "@/pages/AffiliateDisclosure";
import NotFound from "@/pages/NotFound";

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <AnalyticsTracker />
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="reviews" element={<ReviewsIndex />} />
            <Route path="reviews/phrasley-ai" element={<Navigate to="/reviews/phrasly-ai" replace />} />
            <Route path="reviews/:slug" element={<ReviewPage />} />
            <Route path="use-cases" element={<UseCasesIndex />} />
            <Route path="use-cases/:slug" element={<UseCasePage />} />
            <Route path="guides" element={<GuidesIndex />} />
            <Route path="guides/phrasley-case-study-email-copy" element={<Navigate to="/guides/phrasly-case-study-email-copy" replace />} />
            <Route path="guides/:slug" element={<GuidePage />} />
            <Route path="comparison" element={<ComparisonMatrix />} />
            <Route path="resources" element={<Resources />} />
            <Route path="about" element={<About />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="affiliate-disclosure" element={<AffiliateDisclosure />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
